import React, { MouseEvent } from "react";
import {
  availableForSelectedOrderType,
  verifyStatus,
} from "../../../helpers/customizedItem/customizedItem.helper";
import { ICustomizedItem } from "../../../models/item.model";
import { useAppSelector } from "../../../redux/store/store";
import styleClasses from "../try2.module.scss";
import { Helmet } from "react-helmet";
import { getStructuredItem } from "../../../helpers/scripts/seoScript";
import { useStoreLocation } from "../../../context/StoreLocation";
import { isItCreateYourOwnItem } from "../../../helpers/helperMethods";
import { useAuthState } from "../../../context/UserAuthentication";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useLocation } from "react-router";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface FavoriteButtonProps {
  buttonHandler: (e: MouseEvent<HTMLButtonElement>, item) => void;
  favIcon: boolean;
  className: string;
  item?: ICustomizedItem;
  favourite?: any;
  fromOrder?: boolean;
  isIconblueFill: boolean;
}
const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  favIcon,
  className,
  buttonHandler,
  item,
  favourite,
  fromOrder,
  isIconblueFill,
}) => {
  const isOrderTypeSelected = useAppSelector(
    (state) => state.cart.isOrderTypeSelected
  );
  const { authInfo } = useAuthState();
  const savedOrderType = useAppSelector((state) => state.cart.orderType);
  const { locationInfo } = useStoreLocation();
  const orderType = isOrderTypeSelected ? savedOrderType : "";
  const isThisMobile = useCheckMobileScreen();
  const location = useLocation();
  const isDesignV2 = useIsDesignV2()

  const isItemActive = () => {
    // ? This is hardcoded right now because have no constant to distiguise CREATE YOUR OWN SALAD.
    if (
      isItCreateYourOwnItem(item?.is_create_your_own)
    ) {
      return false;
    }
    if (item.is_active && verifyStatus(item, "item_location")) {
      if (availableForSelectedOrderType(item, orderType)) {
        return true;
      }
    } else {
      return false;
    }
  };

  return (
    <>
      {item ?
        <Helmet>
          <script>
            {`
                var el = document.getElementById("favorite_button_${item?.id}")
                if(el) el.addEventListener("click", function () {                      
                          gtag("event", "add_to_wishlist", {
                            user_id: ${authInfo?.userId || null},
                            currency: "USD",
                            value: ${item?.price},
                            items: [
                                ${JSON.stringify(
                getStructuredItem(
                  item as any,
                  locationInfo?.selectedStore?.id
                )
              )}
                            ]
                          });
                        });            
                     `}
          </script>
        </Helmet>
        : null
      }
      
      <button
        type="button"
        id={`favorite_button_${item?.id}`}
        data-testid={`favorite_button_${item?.category_name}_${item?.name}`}
        className={`
        ${styleClasses.favourite_icon_wrap} btn btn-link favourite-icon-wrap ${isDesignV2 && "favourite-icon-wrap_mobile_designv2"} ${className}
      `}
        disabled={fromOrder ? false : !isItemActive()}
        onClick={(e: MouseEvent<HTMLButtonElement>) => buttonHandler(e, item)}
      >
        {
          isDesignV2 ?
<div className='fav-order-btn-mobile-designv2'>
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
          <path 
          style={{
            ...(favourite && {
              fill: isIconblueFill ? "#0956A8" : "#aa182c",
              stroke: isIconblueFill ? "#0956A8" : "#aa182c",
            }),
          }}     
          d="M9.55 16.75C9.55 16.75 0.75 11.6591 0.75 5.47728C0.750179 4.38467 1.11665 3.32585 1.78712 2.48084C2.45758 1.63582 3.39065 1.05677 4.42769 0.842135C5.46472 0.627498 6.5417 0.790522 7.47554 1.30349C8.40937 1.81646 9.1424 2.64771 9.55001 3.65591C9.95761 2.64771 10.6906 1.81647 11.6245 1.30349C12.5583 0.790524 13.6353 0.627498 14.6723 0.842135C15.7093 1.05677 16.6424 1.63582 17.3129 2.48084C17.9833 3.32585 18.3498 4.38467 18.35 5.47728C18.35 11.6591 9.55 16.75 9.55 16.75Z" stroke="#0956A8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
</div>
          :
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="23"
          viewBox="0 0 31 28"
          fill="none"
        >
          <path
          style={{
            ...(favourite && {
              fill: isIconblueFill ? "#0956A8" : "#aa182c",
              stroke: isIconblueFill ? "#0956A8" : "#aa182c",
            }),
          }}          
            d="M15.3643 26.2812C15.3643 26.2812 1 18.2372 1 8.46947C1.00029 6.74307 1.59849 5.07005 2.6929 3.73486C3.78731 2.39967 5.31037 1.48473 7.00313 1.14558C8.69589 0.806437 10.4539 1.06403 11.9782 1.87456C13.5025 2.68509 14.699 3.99853 15.3644 5.59157L15.3643 5.59158C16.0297 3.99854 17.2262 2.6851 18.7505 1.87457C20.2748 1.06403 22.0328 0.806438 23.7255 1.14558C25.4183 1.48472 26.9414 2.39967 28.0358 3.73486C29.1302 5.07005 29.7284 6.74307 29.7287 8.46947C29.7287 18.2372 15.3643 26.2812 15.3643 26.2812Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        }
      </button>
    </>
  );
};
export default FavoriteButton;
